"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteListBtn = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const DeletePopUpLayout_1 = require("../../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../../base/popup");
const constant_1 = require("../../../DSTSL001/constant");
const constant_2 = require("../../constant");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const Colors_1 = require("../../../../../Colors");
exports.DeleteListBtn = react_1.default.memo(({ isTest, isOneDel, deleteList, supportRoomType = undefined, styles, isBackOffice, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteAssignmentList);
    const deletePostMutation = (0, react_query_1.useMutation)(server_1.postDeletePosts);
    const onDelete = async () => {
        const successfulDeletes = [];
        const failedDeletes = [];
        const deleteHandler = async (id, mutation) => {
            try {
                await mutation
                    .mutateAsync(id)
                    .then(data => {
                    // 삭제에 성공한 id를 successfulDeletes 리스트에 추가합니다.
                    successfulDeletes.push(id);
                })
                    .catch(error => {
                    // 삭제에 실패한 id를 failedDeletes 리스트에 추가합니다.
                    failedDeletes.push(id);
                });
                successfulDeletes.push(id);
            }
            catch (error) {
                console.error('Failed to delete post:', error);
                failedDeletes.push(id);
            }
        };
        const deletePromises = deleteList.map(id => {
            return !(supportRoomType === undefined)
                ? deleteHandler(id, deletePostMutation)
                : deleteHandler(id, deleteMutation);
        });
        try {
            // 모든 삭제 작업이 완료될 때까지 기다립니다.
            await Promise.all(deletePromises);
            APP.eventManager.publish('DEL_SUCCESS_LIST', successfulDeletes);
            APP.eventManager.publish(!(supportRoomType === undefined) ? constant_1.REFRESH_POSTS_LIST : constant_2.REFRESH_ASSIGNMENT_LIST);
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
        }
        catch (error) {
            console.error('An error occurred while deleting ids:', error);
        }
    };
    const handlerDel = () => {
        if (deleteList.length <= 0)
            return;
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: deleteList.length
                    ? t('assignment.delteInto', { count: deleteList?.length })
                    : t('common.notSelect'),
                onDelete: onDelete,
            },
            width: 639,
            title: !(supportRoomType === undefined)
                ? t(`supportRoom.${supportRoomType}Delete`)
                : t(`assignment.${isTest ? 'testDelete' : 'delete'}`),
            isFit: true,
        });
    };
    if (isOneDel) {
        return (react_1.default.createElement(common_1.Button, { option: {
                buttonAfterIcon: {
                    show: true,
                    name: 'delete',
                    size: 20,
                    color: Colors_1.Colors.pink,
                },
            }, onClick: () => handlerDel() }));
    }
    return (react_1.default.createElement(common_1.Button, { text: "common.delete", className: `btn_default ${isMobile ? 'mobile-xs' : isTablet ? 'sm' : 'xmd'}`, onClick: handlerDel, styles: { buttonWrap: styles } }));
});
